// extracted by mini-css-extract-plugin
export default {"coinContainer":"Landing_coinContainer__JfBei","input":"Landing_input__70cyR"};